module.exports = __webpack_public_path__ + "img/manut_2410.b64614bf.png";